export default __webpack_public_path__ + "static/media/6.4ec299a7.png";